import type { useWelcomePostsQuery } from '../../hooks/useWelcomePostsQuery'
import { Usage } from '../../types'

export const getUsage = (
  welcomePostsQuery: ReturnType<typeof useWelcomePostsQuery>['welcomePostsQuery'],
): Usage => {
  switch (welcomePostsQuery.data?.type) {
    case 'Single':
      return Usage.same
    case 'Different':
      return Usage.different
    case 'Archived':
    default:
      return Usage.none
  }
}
